import React, { useMemo } from 'react';

export { default as DateFormatter } from './DateFormatter';
export { default as SimpleFormat } from './SimpleFormat';

type NumberFormatterProps = {
  value: number;
  maximumSignificantDigits?: number;
  percentage?: boolean;
};
export function NumberFormatter({ value, maximumSignificantDigits, percentage }: NumberFormatterProps) {
  const formattedValue = useMemo(() => {
    const formatter = new Intl.NumberFormat('en-US', { maximumSignificantDigits });
    return formatter.format(value);
  }, [value, maximumSignificantDigits]);

  if (percentage) {
    return <>{formattedValue}%</>;
  }
  return <>{formattedValue}</>;
}

type CurrencyFormatterProps = {
  value: number;
  currency: 'USD';
};
export function CurrencyFormatter({ value, currency }: CurrencyFormatterProps) {
  const fValue = useMemo(() => {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency });
    return formatter.format(value);
  }, [value, currency]);

  return <>{fValue}</>;
}
